/** Нормализация фото/видео перед загрузкой в медиатеку каталога (Telegram WebView, HEIC, пустой MIME). */

const CATALOG_IMAGE_MIMES = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/webp']);

export function isCatalogVideoFile(file: File): boolean {
  const t = (file.type || '').toLowerCase().split(';')[0].trim();
  return t === 'video/mp4' || /\.mp4$/i.test(file.name || '');
}

export function isSupportedCatalogImageFile(file: File): boolean {
  const t = (file.type || '').toLowerCase().split(';')[0].trim();
  if (CATALOG_IMAGE_MIMES.has(t)) return true;
  const n = (file.name || '').toLowerCase();
  return /\.(jpe?g|png|webp)$/.test(n);
}

/** HEIC/HEIF или «левый» MIME от галереи → JPEG через canvas (iOS/Android WebView). */
export async function normalizeCatalogImageFile(file: File): Promise<File> {
  if (isCatalogVideoFile(file)) return file;
  if (isSupportedCatalogImageFile(file)) {
    const t = (file.type || '').toLowerCase().split(';')[0].trim();
    if (!t && /\.jpe?g$/i.test(file.name || '')) {
      return new File([file], file.name, { type: 'image/jpeg' });
    }
    if (t === 'image/jpg') {
      return new File([file], file.name, { type: 'image/jpeg' });
    }
    return file;
  }

  const bitmap = await createImageBitmap(file);
  try {
    const maxEdge = 2560;
    let { width, height } = bitmap;
    if (width > maxEdge || height > maxEdge) {
      const scale = maxEdge / Math.max(width, height);
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('canvas');
    ctx.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob((b) => resolve(b), 'image/jpeg', 0.92);
    });
    if (!blob) throw new Error('toBlob');
    const base = (file.name || 'photo').replace(/\.[^.]+$/i, '') || 'photo';
    return new File([blob], `${base}.jpg`, { type: 'image/jpeg' });
  } finally {
    bitmap.close?.();
  }
}

export class CatalogMediaNormalizeError extends Error {
  constructor() {
    super('normalize_failed');
    this.name = 'CatalogMediaNormalizeError';
  }
}

export async function prepareCatalogMediaForUpload(file: File): Promise<File> {
  if (isCatalogVideoFile(file)) return file;
  try {
    return await normalizeCatalogImageFile(file);
  } catch {
    throw new CatalogMediaNormalizeError();
  }
}

/** Всегда показываем модалку кропа (в т.ч. pinch на телефоне). Видео — отдельно, без кропа. */
export function preferDirectCatalogFileUpload(): boolean {
  return false;
}
